import { defineComponent as _defineComponent } from 'vue'
import { IEventUserChip } from '@/enitites/event'

import { useImage } from '@/shared/composables/image'
import { ModalWrapper } from '@/shared/ui/modals'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventAllMembers',
  props: {
    isShowModal: { type: Boolean },
    whoIsGoing: null,
    isPastEvent: { type: Boolean }
  },
  emits: ["update:isShowModal"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isShowModal', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const { getImageById } = useImage()




return { __sfc: true,getImageById, emit, ModalWrapper }
}

})